import styled from "styled-components";

//isso aqui é para teste acertar depois
export const HistoricContainer2 = styled.section`
  width: 100%;
  overflow-y: auto;
  position: relative;
`;

//isso aqui é para teste acertar depois
export const MainMessagesContainer2 = styled.div`
  width: 100%;
  height: calc(100% - 60px);
  max-width: 880px;
  padding: 0 16px;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 10px;
  position: relative;
  @media (min-width: 800px) {
    margin: 0 auto;
  }
`;
